module.exports = __webpack_public_path__ + "static/githzerai_anarch-40f08e3f03496c31ebe2dbec95f44f55.png";